import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import styles from "./contact.module.css";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your EmailJS service ID, template ID, and Public Key
    const serviceId = "service_i219ik8";
    const templateId = "template_weqdxpd";
    const publicKey = "mxABhMe0zjagVABMe";

    // Create a new object that contains dynamic template params
    const templateParams = {
      from_name: name,
      from_email: email,
      to_name: "Fernando",
      message: message,
    };

    // Send the email using EmailJS
    if (!(name === "" || email === "" || message === "")) {
      emailjs
        .send(serviceId, templateId, templateParams, publicKey)
        .then((response) => {
          console.log("Email sent successfully!", response);
          setName("");
          setEmail("");
          setMessage("");
        })
        .catch((error) => {
          console.error("Error sending email:", error);
        });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>

        <h1 className={styles.title}>&lt;Contato/&gt;</h1>
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles["form__group"]}>
            <input
              type="input"
              className={styles["form__field"]}
              placeholder=""
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label for="name" className={styles["form__label"]}>
              Nome
            </label>
          </div>
          <div className={styles["form__group"]}>
            <input
              type="email"
              className={styles["form__field"]}
              placeholder=""
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label for="name" className={styles["form__label"]}>
              Email
            </label>
          </div>
          <div className={styles["form__group"]}>
            <textarea
              type="text"
              className={styles["form__field"]}
              placeholder=""
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <label
              for="message"
              data="message"
              className={styles["form__label"]}
            >
              Mensagem
            </label>
          </div>

          <button type="submit" class={styles["button"]}>
            Enviar
          </button>
        </form>
      </div>
      
    </div>
  );
}

export default Contact;
